import { render, staticRenderFns } from "./SituacionDeDesastre.vue?vue&type=template&id=48d4ee0b"
import script from "./SituacionDeDesastre.vue?vue&type=script&lang=js"
export * from "./SituacionDeDesastre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports